import * as Sentry from '@sentry/react';
import { SENTRY_LEVELS, SENTRY_TAGS } from '../constants';

/**
 * Report an error to Sentry with operation context (no PII).
 * Use this instead of console.error for production error tracking.
 */
export const reportError = (
  error: unknown,
  context: {
    operation: string;
    extra?: Record<string, unknown>;
  },
) => {
  Sentry.withScope((scope) => {
    scope.setTag(SENTRY_TAGS.OPERATION, context.operation);

    if (context.extra) {
      scope.setExtras(context.extra);
    }

    Sentry.captureException(error);
  });
};

/**
 * Add a breadcrumb for tracing without reporting an error.
 * Use this to replace console.log for debugging traces.
 */
export const addBreadcrumb = (
  message: string,
  category: string,
  data?: Record<string, unknown>,
) => {
  Sentry.addBreadcrumb({
    message,
    category,
    level: SENTRY_LEVELS.INFO,
    data,
  });
};
